import React from "react";
import { FiArrowLeft, FiShoppingCart, FiEye } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { MdVerified } from "react-icons/md";

function PharmacyOrderDetails() {
  const navigate = useNavigate();

  const products = [
    {
      image: "https://i.pinimg.com/736x/5f/2a/27/5f2a2756630109eff806d9d0016c8753.jpg",
      product: "TEEM 40MG TAB",
      company: "Esteem Pharma",
      mrp: "₹70.31",
      ptr: "₹55.50",
      margin: "11.59%",
      status: "Stock Out",
    },
    {
      image: "https://i.pinimg.com/736x/d5/26/b0/d526b06fb3760ce3f96d4fa22bb12581.jpg",
      product: "DULCOFLEX TAB",
      company: "Sanofi Synthelabo India Pvt Ltd",
      mrp: "₹12.38",
      ptr: "₹9.90",
      margin: "10.44%",
      status: "Stock Out",
    },
    {
      image: "https://i.pinimg.com/736x/5f/2a/27/5f2a2756630109eff806d9d0016c8753.jpg",
      product: "CALCIDOL M TAB",
      company: "Profess Health Products Pvt Ltd",
      mrp: "₹248.44",
      ptr: "₹194.01",
      margin: "12.54%",
      status: "Stock Out",
    },
    {
      image: "https://i.pinimg.com/736x/d5/26/b0/d526b06fb3760ce3f96d4fa22bb12581.jpg",
      product: "GZOR M2 TAB",
      company: "Lloyd Healthcare Pvt Ltd",
      mrp: "₹146.16",
      ptr: "₹111.37",
      margin: "14.66%",
      status: "Stock Out",
    },
  ];

  return (
    <>
    <style>
  {`
    input[type="checkbox"]:checked {
      accent-color: #16a34a !important;
    }
  `}
</style>

    <div className="p-3 sm:p-4 min-h-screen bg-[#f8f8fb] text-gray-800 font-sans">
      {/* Header */}
      <div className="flex flex-wrap justify-between items-center mb-6 gap-3">
        <div>
          <h1 className="text-2xl font-semibold flex items-center gap-2 text-gray-800">
          Ramesh Medicals
            <MdVerified className="text-green-500 text-xl" />
          </h1>
          <p className="text-sm text-gray-500">
           23-567, Mysore Road, Bangalore, Karnataka - 560027
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-green-600 hover:text-green-700 font-medium transition"
          >
            <FiArrowLeft className="text-lg" /> Go Back
          </button>

          <button className="gradient-button flex items-center gap-2 px-4 py-2 rounded-lg shadow text-white text-sm font-medium">
            <FiShoppingCart className="text-lg" /> Add to Cart
          </button>

          <button className="gradient-button flex items-center gap-2 px-4 py-2 rounded-lg shadow text-white text-sm font-medium">
            <FiEye className="text-lg" /> View Cart
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-4">
        {[
          "Search Product",
          "Filter by Composition",
          "Filter by Company",
          "Filter by Location",
          "Filter by Category",
        ].map((ph, i) => (
          <input
            key={i}
            placeholder={ph}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm w-full focus:ring-2 focus:ring-green-400 focus:outline-none"
          />
        ))}
      </div>

      {/* Table */}
    <div className="bg-white rounded-xl shadow-md overflow-x-auto">
  {/* Scrollable Table Wrapper */}
  <div className="max-h-[400px] overflow-y-auto">  
    <table className="w-full text-sm border-collapse">

    <thead className="bg-green-50 text-gray-700 border-b sticky top-0 z-10 shadow-sm">

            <tr>
              <th className="py-2 px-2 text-left font-semibold w-4">
                <input type="checkbox"style={{ accentColor: "#16a34a" }}/>
              </th>
              {[
                "IMAGE",
                "PRODUCT",
                "CATEGORY",
                "MRP",
                "PTR",
                "SCHEME",
                "DISC",
                "MARGIN",
                "MY STATUS",
                "MIN | MAX",
                "MY STK*",
              ].map((h, i) => (
                <th
                  key={i}
                  className={`py-2 px-2 text-left font-semibold whitespace-nowrap ${
                    i === 0 ? "w-[100px]" : ""
                  }`}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {products.map((item, i) => (
              <tr
  key={i}
  className="border-t hover:bg-green-50 transition-colors"
>

                <td className="py-2 px-2">
                <input type="checkbox"style={{ accentColor: "#16a34a" }}/>

                </td>
                <td className="py-2 px-2">
                  <img
                    src={item.image}
                    alt={item.product}
                    className="w-10 h-10 object-contain rounded-md border"
                  />
                </td>
                <td className="py-2 px-2 align-middle">
                  <div className="font-semibold text-gray-800 flex items-center gap-1">
                    {item.product}
                    <MdVerified className="text-green-500 text-sm" />
                  </div>
                  <div className="text-xs text-gray-500">{item.company}</div>
                </td>
                <td className="py-2 px-2 text-gray-500">-</td>
                <td className="py-2 px-2 font-medium">{item.mrp}</td>
                <td className="py-2 px-2 font-medium">{item.ptr}</td>
                <td className="py-2 px-2 text-gray-500">-</td>
                <td className="py-2 px-2 text-gray-500">-</td>
                <td className="py-2 px-2 font-medium text-green-700">
                  {item.margin}
                </td>
                <td className="py-2 px-2">
                  <span className="bg-red-100 text-red-600 text-xs px-3 py-1 rounded-md font-medium">
                    {item.status}
                  </span>
                </td>
                <td className="py-2 px-2 text-gray-500">-</td>
                <td className="py-2 px-2 text-gray-500">-</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>

        {/* Pagination */}
        <div className="flex flex-wrap justify-between items-center py-3 px-4 text-xs text-gray-500 bg-gray-50 border-t gap-2">
          <div>
            To Focus – <span className="font-medium">Up or Down Key</span> | To
            Select – <span className="font-medium">Space</span>
          </div>
          <div className="flex items-center gap-2">
            <button className="text-gray-500 hover:text-green-600">&lt;</button>
            <span className="px-3 py-1 bg-green-100 text-green-700 rounded-md font-medium">
              1
            </span>
            <button className="text-gray-500 hover:text-green-600">&gt;</button>
            <span>20 / page</span>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default PharmacyOrderDetails;
